import React, { useEffect, useState } from 'react';
import '../styles/Records.css';

const getCurrentMonth = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};

const monthsList = () => {
  const now = new Date();
  let arr = [];
  for (let i = 0; i < 12; i++) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
    arr.push(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`);
  }
  return arr;
};

const Records = () => {
  const [summary, setSummary] = useState({
    creditedBank: 0,
    creditedCash: 0,
    spentBank: 0,
    spentCash: 0,
    balanceBank: 0,
    balanceCash: 0
  });
  const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());
  const [creditAmount, setCreditAmount] = useState('');
  const [debitAmount, setDebitAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [actionMsg, setActionMsg] = useState('');

  // Fetch summary data from backend
  const fetchSummary = async (month) => {
    setLoading(true);
    try {
      const res = await fetch(`/backend/api/records_summary.php?month=${month}`);
      const data = await res.json();
      setSummary(data);
    } catch (e) {
      setActionMsg("Failed to load data");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSummary(selectedMonth);
  }, [selectedMonth]);

  const handleCredit = async (e) => {
    e.preventDefault();
    if (!creditAmount || isNaN(creditAmount) || creditAmount <= 0) return;
    setLoading(true);
    try {
      const res = await fetch('/backend/api/bank_credit.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: Number(creditAmount), month: selectedMonth })
      });
      const result = await res.json();
      if (result.success) {
        setActionMsg("Amount credited successfully!");
        setCreditAmount('');
        fetchSummary(selectedMonth);
      } else {
        setActionMsg(result.message || "Error crediting amount");
      }
    } catch {
      setActionMsg("Server error while crediting");
    }
    setLoading(false);
  };

  const handleDebit = async (e) => {
    e.preventDefault();
    if (!debitAmount || isNaN(debitAmount) || debitAmount <= 0) return;
    setLoading(true);
    try {
      const res = await fetch('/backend/api/bank_debit.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: Number(debitAmount), month: selectedMonth })
      });
      const result = await res.json();
      if (result.success) {
        setActionMsg("Amount debited successfully!");
        setDebitAmount('');
        fetchSummary(selectedMonth);
      } else {
        setActionMsg(result.message || "Error debiting amount");
      }
    } catch {
      setActionMsg("Server error while debiting");
    }
    setLoading(false);
  };

  return (
    <div className="records-container">
      <div className="records-header">
        <h2>School Bank & Cash Records</h2>
        <select
          value={selectedMonth}
          onChange={e => setSelectedMonth(e.target.value)}
          className="records-month-dropdown"
        >
          {monthsList().map(month =>
            <option key={month} value={month}>
              {new Date(month + '-01').toLocaleString('default', { month: 'long', year: 'numeric' })}
            </option>
          )}
        </select>
      </div>

      {loading ? <div className="records-loading">Loading...</div> : (
        <div className="records-summary">
          <div className="records-card credit">
            <h3>Total Money Credited in <span>Bank (UPI)</span></h3>
            <p>₹ {summary.creditedBank || 0}</p>
          </div>
          <div className="records-card credit">
            <h3>Total Money Credited via <span>Cash</span></h3>
            <p>₹ {summary.creditedCash || 0}</p>
          </div>
          <div className="records-card debit">
            <h3>Total Money Spent via <span>Bank (UPI)</span></h3>
            <p>₹ {summary.spentBank || 0}</p>
          </div>
          <div className="records-card debit">
            <h3>Total Money Spent via <span>Cash</span></h3>
            <p>₹ {summary.spentCash || 0}</p>
          </div>
          <div className="records-card balance">
            <h3>Remaining Balance in <span>Bank</span></h3>
            <p>₹ {summary.balanceBank || 0}</p>
          </div>
          <div className="records-card balance">
            <h3>Remaining Balance in <span>Cash</span></h3>
            <p>₹ {summary.balanceCash || 0}</p>
          </div>
        </div>
      )}

      <div className="records-bank-actions">
        <form className="records-action-form" onSubmit={handleCredit}>
          <label>Bank Credit (Add money to Bank):</label>
          <input
            type="number"
            min="1"
            value={creditAmount}
            onChange={e => setCreditAmount(e.target.value)}
            placeholder="Enter amount"
            required
          />
          <button type="submit" disabled={loading}>Add</button>
        </form>
        <form className="records-action-form" onSubmit={handleDebit}>
          <label>Bank Debit (Withdraw to Cash):</label>
          <input
            type="number"
            min="1"
            value={debitAmount}
            onChange={e => setDebitAmount(e.target.value)}
            placeholder="Enter amount"
            required
          />
          <button type="submit" disabled={loading}>Debit</button>
        </form>
      </div>

      {actionMsg && <div className="records-msg">{actionMsg}</div>}
    </div>
  );
};

export default Records;
